import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    limit: number = 300,
    trail: string = '...',
  ): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const str = String(value);
    const plainText = str.replace(/<[^>]*>/g, '').trim();

    if (plainText.length <= limit) {
      return plainText;
    }

    return plainText.substring(0, limit).trim() + trail;
  }
}
